export type AdministrationViewProps = {

}

export enum AdministrationViewTypes {
    Notifications = 1,
    Permissions = 2,
    PermissionsExtended = 3
}